<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M5.92,789.05l-2.48,0.67l-6.91,11.99l-1.24,0.33l-0.33-1.24l6.91-11.99l-0.66-2.48l5.09-3.36L5.92,789.05z M-0.3,787.53
	l0.25,0.89l-0.54,0.93h-4.9l-2.19,2.2v5.08h2.9l-1.05,1.81H-9.5v-7.64l3.26-3.26H-0.3z M10.5,787.53v7.65l-3.25,3.25H0.47l1.04-1.81
	h4.97l2.2-2.2v-5.07H7.47l0.11-1.82H10.5z"/>
</svg>

</template>